(() => {
  if (window.__aboutPageInit) return;
  window.__aboutPageInit = true;

  const SELECTOR = '[data-about-reveal]';

  const shouldReduceMotion = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const disableOnMobile =
      document.documentElement.classList.contains('disable-animations') &&
      window.matchMedia('(max-width: 749px)').matches;
    return reduce || disableOnMobile;
  };

  const revealAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => el.classList.add('is-inview'));
  };

  const observe = (root = document) => {
    const nodes = Array.from(root.querySelectorAll(SELECTOR));
    if (!nodes.length) return;

    if (shouldReduceMotion() || !('IntersectionObserver' in window)) {
      revealAll(root);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach((node) => observer.observe(node));
  };

  const init = (root) => observe(root || document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
